import { useTranslation } from 'react-i18next'

import { darkPalette } from '../palette'
import { anim } from '../theme'
import { Eyebrow } from './Eyebrow'

export function ControlSection() {
  const { t } = useTranslation()

  const levels = [
    {
      badge: t('landing.control.level1Badge'),
      title: t('landing.control.level1Title'),
      desc: t('landing.control.level1Desc'),
      border: `1px solid ${darkPalette.borderCard}`,
      background: darkPalette.cardBg,
      badgeBg: darkPalette.levelObserveBg,
      badgeFg: darkPalette.levelObserveFg,
      descColor: darkPalette.fgSofter,
    },
    {
      badge: t('landing.control.level2Badge'),
      title: t('landing.control.level2Title'),
      desc: t('landing.control.level2Desc'),
      border: `1.5px solid ${darkPalette.levelSuggestBorder}`,
      background: darkPalette.levelSuggestBg,
      badgeBg: darkPalette.levelSuggestBadgeBg,
      badgeFg: darkPalette.levelSuggestBadgeFg,
      descColor: darkPalette.levelSuggestDesc,
    },
    {
      badge: t('landing.control.level3Badge'),
      title: t('landing.control.level3Title'),
      desc: t('landing.control.level3Desc'),
      border: `1px solid ${darkPalette.levelAutoBorder}`,
      background: darkPalette.levelAutoBg,
      badgeBg: darkPalette.levelAutoBadgeBg,
      badgeFg: darkPalette.levelAutoBadgeFg,
      descColor: darkPalette.levelAutoDesc,
    },
  ]

  const guarantees = [
    { title: t('landing.control.guarantee1Title'), desc: t('landing.control.guarantee1Desc') },
    { title: t('landing.control.guarantee2Title'), desc: t('landing.control.guarantee2Desc') },
    { title: t('landing.control.guarantee3Title'), desc: t('landing.control.guarantee3Desc') },
    { title: t('landing.control.guarantee4Title'), desc: t('landing.control.guarantee4Desc') },
  ]

  return (
    <section
      id="controle"
      style={{
        background: darkPalette.bg,
        color: darkPalette.fg,
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <div
        data-decor=""
        aria-hidden="true"
        style={{
          position: 'absolute',
          top: -160,
          right: -80,
          width: 520,
          height: 520,
          borderRadius: '50%',
          background: 'radial-gradient(circle, oklch(70% 0.14 233 / 0.3), transparent 65%)',
          filter: 'blur(40px)',
          animation: anim.blobControle,
          pointerEvents: 'none',
        }}
      />
      <div
        style={{
          position: 'relative',
          maxWidth: 1200,
          margin: '0 auto',
          padding: '88px 24px',
          display: 'flex',
          flexDirection: 'column',
          gap: 44,
        }}
      >
        <div
          data-reveal=""
          style={{ display: 'flex', flexDirection: 'column', gap: 14, maxWidth: 640 }}
        >
          <Eyebrow tone="dark">{t('landing.control.eyebrow')}</Eyebrow>
          <h2
            style={{
              margin: 0,
              fontSize: 'clamp(28px,3.2vw,42px)',
              lineHeight: 1.1,
              fontWeight: 600,
              letterSpacing: '-0.035em',
            }}
          >
            {t('landing.control.title')}
          </h2>
          <p style={{ margin: 0, fontSize: 16.5, lineHeight: 1.65, color: darkPalette.fgSoft }}>
            {t('landing.control.subtitle')}
          </p>
        </div>

        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit,minmax(260px,1fr))',
            gap: 18,
          }}
        >
          {levels.map((level) => (
            <div
              key={level.title}
              data-reveal=""
              style={{
                border: level.border,
                borderRadius: 16,
                background: level.background,
                padding: 24,
                display: 'flex',
                flexDirection: 'column',
                gap: 10,
              }}
            >
              <span
                style={{
                  alignSelf: 'flex-start',
                  fontSize: 11.5,
                  fontWeight: 700,
                  padding: '4px 11px',
                  borderRadius: 999,
                  background: level.badgeBg,
                  color: level.badgeFg,
                }}
              >
                {level.badge}
              </span>
              <span style={{ fontSize: 16, fontWeight: 700 }}>{level.title}</span>
              <span style={{ fontSize: 14, lineHeight: 1.6, color: level.descColor }}>
                {level.desc}
              </span>
            </div>
          ))}
        </div>

        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit,minmax(240px,1fr))',
            gap: 18,
            paddingTop: 12,
            borderTop: `1px solid ${darkPalette.border}`,
          }}
        >
          {guarantees.map((guarantee) => (
            <div
              key={guarantee.title}
              data-reveal=""
              style={{ display: 'flex', flexDirection: 'column', gap: 7 }}
            >
              <span style={{ fontSize: 15, fontWeight: 700 }}>{guarantee.title}</span>
              <span style={{ fontSize: 13.5, lineHeight: 1.6, color: darkPalette.fgSofter }}>
                {guarantee.desc}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
